import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, toPlainObject } from 'lodash';

import { FRAUDSTER_TOOL_KYC } from '../../../constants/fraud';
import { KYC_STATE_VALIDATED } from '../../../services/kyc/constants';

import { lockEbons } from '../../../services/ebon/actions';

const FunnelFraudVerificationStep = ({
    partnerId,
    userInfo,
    kycNeeded,
    setKycNeeded,
    ebon,
    lock,
    kycState,
    user,
    lockEbons
}) => {
    const [kycValidated, setKycValidated] = useState(false);

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            // Get fraudster tools
            const suspected =
                lock[0].fraudsterProbability && lock[0].fraudsterProbability.suspected;
            const fraudsterTools = suspected && lock[0].fraudsterProbability.tools;
            const identityVerified = suspected && lock[0].fraudsterProbability.identityVerified;

            // Use appropriate fraudster tool
            if (suspected && fraudsterTools.includes(FRAUDSTER_TOOL_KYC) && !identityVerified) {
                setKycNeeded(true);
            } else {
                setKycNeeded(false);
            }
        }
    }, [lock]);

    /* Start KYC verification */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            setKycValidated(true);
        }
    }, [kycState]);

    useEffect(() => {
        if (kycNeeded && kycValidated) {
            doLock();
        }
    }, [kycValidated]);
    /* End KYC verification */

    // Do new lock if KYC is validated to check if the user is still suspected
    const doLock = async () => {
        const ebonCart = {
            lockRequests: ebon.cart,
            userId: user.username,
            partnerId: partnerId,
            fixedFacialValue: !hasFreeFacial
        };

        lockEbons(ebonCart, userInfo.phoneNumber);
    };

    return null;
};

FunnelFraudVerificationStep.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    kycNeeded: PropTypes.bool,
    setKycNeeded: PropTypes.func
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        ebon: state.ebon,
        lock: state.ebon.lock,
        kycState: state.kyc.state,
        user: user
    };
};

const mapDispatchToProps = {
    lockEbons
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelFraudVerificationStep);



// WEBPACK FOOTER //
// ./src/components/funnel/fraud-verification-step/FunnelFraudVerificationStep.js